import React from 'react';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { toLowerCase } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

import IncreaseLimitButton from './IncreaseLimitButton';
import { LimitBlock } from './LimitBlock';

const GaBasicAndUpgradableLimit = ({ title, lang, country }) => {
    const { limits, alarmLimits } = useExtra();
    const { gaLimitsTitle, gaLimitsATMLimitResetLimitInfo, profileSpent } = usePageMessages();

    return (
        <>
            <HeaderPanel title={gaLimitsTitle} indentCompact />
            <Row indent="adaptive-32-48">
                <LimitBlock
                    title={title}
                    spendSum={getLocalizedRawAmount(lang, country, limits.used)}
                    spendText={profileSpent}
                    leftSum={getLocalizedRawAmount(lang, country, limits.left)}
                    leftText={gaLimitsATMLimitResetLimitInfo}
                    isExhaustedLimit={alarmLimits <= limits.usedPercent}
                    currency={toLowerCase(limits.currencyCode)}
                    progressWidth={limits.usedPercent}
                />
            </Row>
            <Row indent="adaptive-16-24">
                <IncreaseLimitButton />
            </Row>
        </>
    );
};
export default GaBasicAndUpgradableLimit;
